import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Search, Heart, ShoppingBag, User } from 'lucide-react';

export default function MobileBottomNav() {
  const { pathname } = useLocation();
  const items = [
    { to: '/', label: 'Home', icon: Home },
    { to: '/search', label: 'Explore', icon: Search },
    { to: '/wishlist', label: 'Wishlist', icon: Heart },
    { to: '/checkout', label: 'Cart', icon: ShoppingBag },
    { to: '/account', label: 'Account', icon: User },
  ];
  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 z-30">
      <div className="grid grid-cols-5">
        {items.map((it) => {
          const Icon = it.icon;
          const active = pathname === it.to || (it.to !== '/' && pathname.startsWith(it.to));
          return (
            <Link key={it.to} to={it.to} className={`flex flex-col items-center gap-0.5 py-2.5 text-[10px] ${active ? 'text-xlook-orange' : 'text-gray-500'}`}>
              <Icon className="w-5 h-5" strokeWidth={active ? 2.2 : 1.8} />
              <span className="font-medium">{it.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
